import React, { useState } from 'react';
import Dialog from '../../components/Dialog';
import { IconPencil } from '../../components/dialogIcons';

/*
  The few words an administrator sends back to a rep.

  Built 5 September 2026 to Group E's approved drawing `dialog-reason-*.png`.

  **One dialog with five uses**, which the owner confirmed on 3 September: send
  a count back, deny an edit request, deny a closure, deny a transfer, and the
  optional note on a confirmed closure. They are the same thing, a few words
  that go to the rep, and the running app wrote them out three times in three
  different row files.

  **It exists because the Review Hub becoming a page nearly lost it.** The old
  rows had a reason box that unfolded inside the row; the page's Send back
  passed an empty string, so a rep would have got "your count was sent back" and
  nothing else. Caught by reading the diff rather than by looking at it, because
  a missing sentence is not something a photograph shows.

  **The act names the person**, the way the transfer button does: a button that
  names somebody is hard to press by accident.
*/
export default function ReasonDialog({ title, record, says, label, placeholder, act, tone = 'danger', actClass = 'btn-danger', required = true, onSend, onClose }) {
  const [words, setWords] = useState('');
  const [busy, setBusy] = useState(false);
  const ready = !required || words.trim().length > 0;

  async function send() {
    if (!ready || busy) return;
    setBusy(true);
    await onSend(words.trim());
    setBusy(false);
  }

  return (
    <Dialog
      kind={tone} icon={<IconPencil />}
      title={title} record={record} says={says}
      onClose={onClose}
      footer={
        <>
          <button className="btn btn-quiet" onClick={onClose}>Cancel</button>
          <button className={'btn ' + actClass} onClick={send} disabled={!ready || busy}>
            {busy ? 'Sending...' : act}
          </button>
        </>
      }
    >
      <div className="form-lbl" style={{ marginTop: 0 }}>{label}</div>
      <textarea className="form-ta" value={words} onChange={e => setWords(e.target.value)}
        placeholder={placeholder} autoFocus />
    </Dialog>
  );
}
